import parse, {
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";
import type { ReactNode } from "react";

/**
 * Default parse options
 */
const defaultParseOptions: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element) {
      const { attribs, children } = domNode;

      if (!attribs) return;
    }

    return undefined;
  },
};

interface SanitizeDOMDataOptions extends HTMLReactParserOptions {}

/**
 * Sanitize + parse HTML string to ReactNode
 */
export default function sanitizeDOMData(
  htmlString: string,
  options: SanitizeDOMDataOptions = {}
): ReactNode {
  return parse(htmlString, {
    ...defaultParseOptions,
    ...options,
    trim: true,
  });
}
